export default __webpack_public_path__ + "static/media/background.056a72db.png";